import React from 'react';
export const WinRateCell = ({ winRate })=>/*#__PURE__*/ React.createElement("div", null, winRate.toFixed(1), "%");
